<template>
  <div class="grid">
    <div v-for="tile in tiles" :is="tile.type" :data="tile.data" class="grid__tile"></div>
  </div>
</template>

<script>
import Tile from './Tile'
import TileGrid from './TileGrid'

export default {
  name: 'grid',
  props: ['tiles'],
  components: { Tile, TileGrid }
}
</script>

<style lang="scss">
@import '~sass/tools';

.grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;

  &__tile {
    flex: 1 0 0;
    min-width: 35%;
    margin-bottom: 1.5rem;
    background-color: cc(bg);
    @include boxShadow;

    &:nth-of-type(even) {
      margin-left: 1.25rem;
    }

    &--grid {
      display: flex;
      flex-wrap: wrap;
      align-items: stretch;
      align-content: stretch;
      background-color: transparent;
      box-shadow: none;

      .grid__tile {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &:last-of-type,
        &:nth-last-of-type(2) {
          margin-bottom: 0;
        }
      }
    }
  }

  &__title {
    position: relative;
    padding: 1rem;
    border-bottom: 1px solid cc(border);
    @include montserrat(20px);
  }

  &__options {
    transition: color 150ms cb(io);
    position: absolute;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: cc(label,.5);

    &:hover {
      color: cc(label);
    }

    i,
    &::before,
    &::after {
      display: inline-block;
      margin: .25rem .15rem;
      padding: .25rem;
      background-color: currentColor;
      border-radius: 100%;
    }

    &::before,
    &::after {
      content: '';
    }
  }

  &__label {
    margin-top: .5rem;
    color: cc(text,alt);
    @include label-text;
  }

  &__data {
    color: cc(primary);
    @include title-text;
  }
}
</style>



// WEBPACK FOOTER //
// Grid.vue?07ec6422